import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1053"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.568 5.11c.092.018 1.436.274 3.01.274 1.027 0 2.151-.11 3.09-.466 3.717-1.409 6.153.074 6.251.136a.704.704 0 0 0 .76-1.182c-.124-.079-3.099-1.941-7.509-.268-2.003.759-5.3.134-5.333.126a.703.703 0 0 0-.269 1.38zm13.109 2.616c-.124-.079-3.101-1.941-7.509-.268-2.002.76-5.299.132-5.331.125a.703.703 0 0 0-.269 1.38c.091.018 1.435.273 3.008.273 1.027 0 2.152-.109 3.091-.466 3.721-1.41 6.153.074 6.251.136a.7.7 0 1 0 .759-1.18zm0 3.853c-.124-.079-3.099-1.942-7.509-.268-2.002.758-5.299.132-5.332.124a.703.703 0 0 0-.269 1.38c.092.018 1.436.274 3.01.274 1.027 0 2.151-.11 3.089-.466 3.721-1.41 6.153.074 6.251.136.325.208.76.116.971-.211a.7.7 0 0 0-.211-.969z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }